var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartyroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8379 28.3027H18.5234C18.3941 28.3027 18.2891 28.1977 18.2891 28.0684V27.6863C18.2891 27.3465 18.5656 27.0703 18.9055 27.0703H21.4559C21.7957 27.0703 22.0719 27.3465 22.0719 27.6863V28.0684C22.0719 28.1977 21.9672 28.3027 21.8379 28.3027Z",
    fill: "#27A376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5195 26.6V21.0273H20.8488V26.6H19.5195Z",
    fill: "#27A376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.977 20.5605H14.0262C13.5527 20.5605 13.168 20.1754 13.168 19.7023V19.0781C13.168 18.9488 13.2727 18.8438 13.402 18.8438H26.6012C26.7305 18.8438 26.8355 18.9488 26.8355 19.0781V19.7023C26.8355 20.1754 26.4504 20.5605 25.977 20.5605Z",
    fill: "#27A376"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7625 23.1805H23.4371C23.3078 23.1805 23.2031 23.0758 23.2031 22.9465V21.5691C23.2031 21.4395 23.3078 21.3348 23.4371 21.3348H28.1512V15.8863C28.1512 15.757 28.2559 15.6523 28.3855 15.6523H29.7625C29.8922 15.6523 29.9969 15.757 29.9969 15.8863V22.9465C29.9969 23.0758 29.8918 23.1805 29.7625 23.1805Z",
    fill: "#27A376"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7629 28.1148H28.5195C28.3902 28.1148 28.2852 28.0102 28.2852 27.8809V23.6484H29.9973V27.8809C29.9973 28.0102 29.8922 28.1148 29.7629 28.1148Z",
    fill: "#27A376"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9988 19.3125H22.5547C22.425 19.3125 22.3203 19.2074 22.3203 19.0781C22.3203 18.9488 22.425 18.8438 22.5547 18.8438H23.9988C24.1285 18.8438 24.2332 18.9488 24.2332 19.0781C24.2332 19.2074 24.1285 19.3125 23.9988 19.3125Z",
    fill: "#27A376"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6809 28.1148H23.4371C23.3078 28.1148 23.2031 28.0102 23.2031 27.8809V23.6484H24.9152V27.8809C24.9152 28.0102 24.8102 28.1148 24.6809 28.1148Z",
    fill: "#27A376"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5633 23.1805H10.2383C10.1086 23.1805 10.0039 23.0758 10.0039 22.9465V15.8863C10.0039 15.757 10.1086 15.6523 10.2383 15.6523H11.6152C11.7449 15.6523 11.8496 15.757 11.8496 15.8863V21.3348H16.5633C16.693 21.3348 16.7977 21.4395 16.7977 21.5688V22.9461C16.7977 23.0758 16.693 23.1805 16.5633 23.1805Z",
    fill: "#27A376"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4816 28.1148H10.2383C10.1086 28.1148 10.0039 28.0102 10.0039 27.8809V23.6484H11.716V27.8809C11.716 28.0102 11.6109 28.1148 11.4816 28.1148Z",
    fill: "#27A376"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5641 28.1148H15.3203C15.191 28.1148 15.0859 28.0102 15.0859 27.8809V23.6484H16.798V27.8809C16.798 28.0102 16.6934 28.1148 16.5641 28.1148Z",
    fill: "#27A376"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2762 17.868C22.5293 17.868 21.9219 17.2605 21.9219 16.5137V15.9434H24.6301V16.5137C24.6301 17.2605 24.0227 17.868 23.2762 17.868ZM21.9219 15.4746V14.9961C21.9219 14.8668 22.0266 14.7617 22.1562 14.7617L24.3957 14.7621C24.5254 14.7621 24.6301 14.8668 24.6301 14.9961V15.4746H21.9219Z",
    fill: "#27A376"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2773 19.3113C23.1477 19.3113 23.043 19.2063 23.043 19.077V17.6324C23.043 17.5031 23.1477 17.3984 23.2773 17.3984C23.4066 17.3984 23.5113 17.5031 23.5113 17.6324V19.077C23.5113 19.2063 23.4066 19.3113 23.2773 19.3113Z",
    fill: "#27A376"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.027 19.3102H16.2816C15.9563 19.3102 15.6914 19.0453 15.6914 18.7199V15.5176C15.6914 14.9766 15.9867 14.4883 16.4555 14.2332V13.457H17.8527V14.2332C18.3219 14.4883 18.6172 14.9766 18.6172 15.5176V18.7199C18.6172 19.0453 18.3523 19.3102 18.027 19.3102ZM17.1543 17.373C17.0922 17.373 17.0324 17.3484 16.9883 17.3043C16.6055 16.9215 16.2098 16.5258 16.2098 16.0734C16.2098 15.7484 16.4742 15.484 16.7992 15.484C16.9527 15.484 17.0668 15.5316 17.1543 15.6008C17.2414 15.5316 17.3555 15.484 17.5094 15.484C17.8344 15.484 18.0984 15.7484 18.0984 16.0734C18.0984 16.5258 17.7027 16.9215 17.3199 17.3043C17.2758 17.3484 17.2164 17.373 17.1543 17.373ZM16.7992 15.9527C16.7324 15.9527 16.6785 16.007 16.6785 16.0734C16.6785 16.2859 16.8996 16.5449 17.1543 16.8059C17.4086 16.5449 17.6301 16.2859 17.6301 16.0734C17.6301 16.007 17.5758 15.9527 17.5094 15.9527C17.4578 15.9527 17.432 15.9527 17.3637 16.0895C17.3242 16.1688 17.243 16.2191 17.1543 16.2191C17.0656 16.2191 16.9844 16.1688 16.9445 16.0895C16.8762 15.9527 16.8504 15.9527 16.7992 15.9527Z",
    fill: "#27A376"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0273 12.9898H16.2848C16.1555 12.9898 16.0508 12.8848 16.0508 12.7555V11.9297C16.0508 11.8004 16.1555 11.6953 16.2848 11.6953H18.0273C18.1566 11.6953 18.2617 11.8004 18.2617 11.9297V12.7555C18.2617 12.8848 18.1566 12.9898 18.0273 12.9898Z",
    fill: "#27A376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyroom);
export default __webpack_public_path__ + "static/media/partyroom.bacbbdd0a334841a5742e4cfb025000e.svg";
export { ForwardRef as ReactComponent };